import { PermissionAssignmentReportType } from "../../../../features/Capacity/DepartmentReport/Domain/department-monitoring.types";
import { useRemoteQuery } from "../../useRemote/useRemoteQuery";

type RemoteFetchDepartmentMonitoringDto = {
  reportDate: string;
};

export const useRemoteFetchDepartmentMonitoringReport = (
  filter: RemoteFetchDepartmentMonitoringDto
) => {
  return useRemoteQuery<PermissionAssignmentReportType>({
    queryKey: JSON.stringify(filter),
    url: `permission-assignment-report/permission-assignment-report-values`,
    params: filter,
    enabled: !!filter.reportDate
  });
};
